import { useResource } from "../../../Hooks/UseResource";

export default function OtpResource() {
  const [, , , postData] = useResource();

  const sendOTP = (data) => {
    return postData(
      {
        url: "/validate-and-send-otp/mobile/mobileCountryCode",
        data: data,
      },
      true,
      true,
    );
  };

  const verifyOTP = (data) => {
    return postData({ url: "/verify-otp/web/otp", data: data }, true, true);
  };

  const logout = () => {
    return postData({
      url: "/kyc-logout",
      data: {},
    });
  };

  return { sendOTP, verifyOTP, logout };
}
